var _a, _b;
import React, { useEffect, useState } from 'react';
import { useComponents } from '@tencent/dz-elements';
import { RecommendCard } from './components';
import styles from './style/index.less';
import { useHeaderModel } from '../../../hooks';
import { MessageType } from '@tencent/dz-models';
// 组件Map
var typeAndComponentMap = (_a = {},
    _a[MessageType.QuestionRecommen] = RecommendCard,
    _a);
// id Map
var typeIdMap = (_b = {},
    _b[MessageType.QuestionRecommen] = 'guess_question_top',
    _b);
export var TopCard = function () {
    var headerModel = useHeaderModel();
    var topCardMessage = headerModel.topCardMessage, isShowTopCard = headerModel.isShowTopCard, hospital = headerModel.hospital;
    // 倒计时
    var _a = useState(20), second = _a[0], setSecond = _a[1];
    // topcard 位置
    var _b = useState(true), isInit = _b[0], setIsInit = _b[1];
    var _c = useState(0), location = _c[0], setLocation = _c[1];
    var View = useComponents().View;
    // 关闭顶部显示
    var onClickClose = function () {
        headerModel.updateIsShowTopCard(false);
    };
    var getCardLocation = function () {
        setIsInit(false);
        // 获取元素高度
        if (!(hospital === null || hospital === void 0 ? void 0 : hospital.hospitalId))
            return;
        var ele = document.querySelector('#fixed-search-Hospital');
        if (ele) {
            var react = ele.getBoundingClientRect();
            setLocation((react === null || react === void 0 ? void 0 : react.height) || 84);
        }
        else {
            setLocation(84);
        }
    };
    useEffect(function () {
        if (!topCardMessage || !isShowTopCard)
            return;
        isInit && getCardLocation();
        // 设置20秒定时器
        var delaySecond = 20;
        var _loop_1 = function (i) {
            setTimeout(function () {
                setSecond(delaySecond - i);
            }, i * 1000);
        };
        for (var i = 0; i <= delaySecond; i++) {
            _loop_1(i);
        }
        ;
    }, [topCardMessage, isShowTopCard]);
    if (!isShowTopCard)
        return null;
    // 是否有顶部内容
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var Component = typeAndComponentMap[topCardMessage === null || topCardMessage === void 0 ? void 0 : topCardMessage.type];
    if (!Component)
        return null;
    return (React.createElement(View, { className: styles['fixed-top-card'], id: typeIdMap[topCardMessage === null || topCardMessage === void 0 ? void 0 : topCardMessage.type], style: { transform: "translateY(" + location + "px)" } },
        second === 0 ? React.createElement(View, { className: styles['right-icon'] + " " + styles.close, onClick: onClickClose }) : React.createElement(View, { className: styles['right-icon'] },
            React.createElement(View, { className: styles.time }, second)),
        React.createElement(View, { className: styles['fixed-top-card-content'] },
            React.createElement(Component, { messageState: topCardMessage }))));
};
